import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Checkbox,
  Collapse,
  FormControlLabel,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useState } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

function CheckedListView({ title, listData, checked, handleToggle, handleSelectAll, expand }) {
  const [openList, setOpenList] = useState(expand);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const handleListClick = () => {
    setOpenList(!openList);
  };
  return (
    <Grid pb={1}>
      <Card>
        <MDBox pt={0.5} px={0.5} pb={0.5}>
          <List
            sx={{
              bgcolor: darkMode ? "black" : "background.paper",
              maxHeight: 250,
              overflow: "auto",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            <ListItemButton onClick={handleListClick}>
              <ListItemText primary={<MDTypography variant="h6">{title}</MDTypography>} />
              {openList ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openList} timeout="auto" unmountOnExit>
              <FormControlLabel
                label="Select All"
                id={`label_${title}`}
                sx={{ paddingLeft: "8px" }}
                control={
                  <Checkbox
                    color="primary"
                    checked={listData.length === checked.length}
                    inputProps={{ "aria-labelledby": `check_${title}` }}
                    onChange={(e) => handleSelectAll(e, title)}
                  />
                }
              />
              {listData.map((value) => {
                const labelId = `checkbox-list-label-${value}`;
                return (
                  <List component="div" disablePadding>
                    <ListItemButton
                      role={undefined}
                      onClick={() => handleToggle(title, value)}
                      dense
                      sx={{ pl: 1 }}
                    >
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(value) !== -1}
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                      <ListItemText
                        id={labelId}
                        primary={
                          <MDTypography fontWeight="medium" variant="caption">
                            {value}
                          </MDTypography>
                        }
                      />
                    </ListItemButton>
                  </List>
                );
              })}
            </Collapse>
          </List>
        </MDBox>
      </Card>
    </Grid>
  );
}
CheckedListView.defaultProps = {
  expand: false,
};
CheckedListView.propTypes = {
  title: PropTypes.string.isRequired,
  listData: PropTypes.arrayOf(PropTypes.string).isRequired,
  checked: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleToggle: PropTypes.func.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  expand: PropTypes.bool,
};
export default CheckedListView;
